<app-dialog-heading [heading]="data.heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="reasoningFormGroup">
    <mat-form-field>
      <mat-label>Reason</mat-label>
      <textarea type="text" matInput [rows]="defaultRows"
                [formControlName]="Controls.Reason"></textarea>
    </mat-form-field>
  </form>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="primary" (click)="onClickSave()" [disabled]="!reasoningFormGroup.valid">Save</button>
  <button class="dialog-button" mat-raised-button color="warn" (click)="onClickCancel()">Cancel</button>
</mat-dialog-actions>